import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { useCardControls } from '../../lib/card-controls-context';
import { ControlIcon } from './ControlIcon';

// The page lock's line on a card (#6753, prototype `:2316`, one sentence for every control,
// deviation 3): "Too many changes in a row. Controls unlock in <n> s.", counting down each
// second, above the card's controls. The page announces the lock and its lift once
// (`ControlLockStatus`), so this line is not a live region: twelve cards would say it twelve
// times. The number changes with no animation (reduced motion is a still frame anyway).

export function ControlLock(): JSX.Element {
  const handle = useCardControls();
  const seconds = () => (handle?.on() === true ? handle.card.locked() : 0);
  return (
    <Show when={seconds() > 0}>
      <p class="mission-ctl__lock">
        <ControlIcon glyph="pause" />
        <span>{t('fleet.machines.ctl_locked', { n: seconds() })}</span>
      </p>
    </Show>
  );
}
